export default "__VITE_ASSET__CrjHTwow__";